import React from "react";
import "../styles/News.css";

function NewsCard({ articles, titles, dates, border }) {
  return (
    <div className={border} style={{ width: "18rem" }}>
      <div className="card-body text-dark">
        <h5 className="card-title ">{titles}</h5>
        <p className="card-text">{articles}</p>
        <p className="card-text">
          <small className="text-muted">{dates}</small>
        </p>
      </div>
    </div>
  );
}

export default NewsCard;
